import { Input } from "antd";
import classnames from "classnames";
import PropTypes from "prop-types";
import { MdCheck, MdPriorityHigh, MdLock } from "react-icons/md";

import Label from "shared/components/Label";

const Password = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  labelSuffix,
  required,
  direction,
  optional,
  right,
  column,
  success,
  showSuccessIcon = true,
  ...rest
}) => {
  const hasValue =
    rest.value !== undefined &&
    rest.value !== null &&
    `${rest.value}`.trim() !== "";

  return (
    <div
      className={classnames(
        "input__wrapper input__wrapper--password",
        {
          __error: touched && errors,
          __success: success && !errors,
        },
        direction || column,
      )}
    >
      <Label
        label={label}
        icon={icon}
        labelSuffix={labelSuffix}
        required={required}
        optional={optional}
        right={right}
      />
      <div className={`input__wrapper--field`}>
        <Input.Password
          className={classnames({
            "password--input": true,
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
            "input--filled": hasValue,
          })}
          placeholder={placeholder}
          {...rest}
        />

        {touched && errors && (
          <MdPriorityHigh className="input--error-icon" size={20} />
        )}

        {success && showSuccessIcon && !errors && (
          <MdCheck className="input--success-icon" size={20} />
        )}

        {rest.disabled && !touched && (
          <MdLock className="input--disabled-icon" size={16} />
        )}

      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

Password.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Password.defaultProps = {
  label: "",
  placeholder: "",
};

export default Password;
